import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "q-pa-sm bg-white",
  style: {"min-width":"500px"}
}


import { useDialogPluginComponent } from 'quasar'
import { ResultCard } from '@/components'


export default /*#__PURE__*/_defineComponent({
  props: {
  answerHash: { type: String, requierd: true },
},
  emits: { ...useDialogPluginComponent.emits },
  setup(__props) {

// TODO: defineProps defineEmits インポートしないとエラーが出るのでひとまずそのまま




const { dialogRef, onDialogHide } = useDialogPluginComponent()

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref: (_value, _refs) => {
      _refs['dialogRef'] = _value
      _isRef(dialogRef) && (dialogRef.value = _value)
    }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(ResultCard), {
          answerHash: __props.answerHash,
          class: "q-mb-sm"
        }, null, 8, ["answerHash"]),
        _createVNode(_component_q_btn, {
          onClick: _unref(onDialogHide),
          unelevated: "",
          color: "primary",
          label: "閉じる",
          padding: "12px",
          class: "full-width"
        }, null, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 512))
}
}

})